var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"popup"}},[_c('Photo',{on:{"close":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }